import { render, staticRenderFns } from "./flavor.vue?vue&type=template&id=c4e511b8&"
import script from "./flavor.vue?vue&type=script&lang=js&"
export * from "./flavor.vue?vue&type=script&lang=js&"
import style0 from "./flavor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports